export default {
  /**
   * 获取 intercom 接入配置
   */
  getIntercomConfig: '/api/intercom/get-config',
}
